// src/utils/apiClient.js
import axios from 'axios';
import { encryptAES, decryptAES } from './cryptoUtils';
import { getApgJWT } from './getApgJWT';
import { updateUserIdSSO } from './apiClient3';
// Create a custom axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, 
  // If you need withCredentials for cookies, set it here:
  withCredentials: true,
});

// REQUEST INTERCEPTOR
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Always fetch a fresh token or use cached logic inside getApgJWT
      const token = await getApgJWT();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['X-User-Id'] = localStorage.getItem('ntid')
        config.headers['X-Application-Id'] = 'Liva'
        config.headers['X-Session-Id'] = localStorage.getItem('session_id')
        
      }
    } catch (err) {
      console.error('Error fetching apg jwt token:', err);
    }

    if (config.method === 'post') {
      // Convert the data to JSON string
      const plainDataString = JSON.stringify(config.data);
      console.log('plainDataString:', plainDataString);
      // Encrypt
      const encryptedPayload = encryptAES(plainDataString);
      // Replace the payload
      config.data = { encryptedRequest: encryptedPayload };
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
apiClient.interceptors.response.use(
  (response) => {
    // If there's an 'encryptedResponse' field, decrypt it
    if (response.data && response.data.encryptedResponse) {
      try {
        const decryptedString = decryptAES(response.data.encryptedResponse);
        // parse to JS object
        const plainObject = JSON.parse(decryptedString);
        console.log("decrypted", plainObject);

        // replace data in the response
        response.data = plainObject;
      } catch (err) {
        console.error('Decryption error:', err);
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if error status is 401 and the request has not been retried yet
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      console.log("token updating errror")
      originalRequest._retry = true;
      console.log("token updating hereee")
      let ssoKey = localStorage.getItem('originsl_ssoKey' )
      let userId = localStorage.getItem('original_userId')
      let user_type = localStorage.getItem('original_user_type')  
      console.log("token updating heree")
      localStorage.removeItem('session_token')          
      const res = await updateUserIdSSO(ssoKey, userId, user_type);
      console.log("token updating response",res)
      if ('jwt-token' in res) {
        console.log("token updating")
              localStorage.setItem('session_token', res['jwt-token']);
      }
      try {
        console.log("debug2", originalRequest)
        console.log("debug333", originalRequest.method == 'post', originalRequest.data , originalRequest.data.encryptedRequest)
        // Parse original payload if it was a post request to prevent double encryption
        if (originalRequest.method == 'post') {
          console.log("debug 95")
          const decryptedString = decryptAES(JSON.parse(originalRequest.data)['encryptedRequest']);
          console.log(decryptedString)
          originalRequest.data = JSON.parse(decryptedString);
          console.log("debug", originalRequest.data)
        }

        // Re-execute the request. The request interceptor will fetch the new token automatically.
        return apiClient(originalRequest);
      } catch (retryError) {
        return Promise.reject(retryError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
